const promoTextObject = {
    configName: 'promo',
    container: null,
    elements: [],
    firstFrameShift: .7,
    parallaxElements: [],
    parallaxFriction: .1,
    point: null,
    status: -1,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;
        this.container = document.querySelector('.promo-text');
        const config = main.detectScroll.getConfig(this.configName);

        const elements = this.container.getElementsByClassName('promo-text__block');
        this.point = config.height / (elements.length + 2);
        let calcPoint = this.point;
        const step = (config.height - this.point * 3) / elements.length;
        let count = 0;

        for (const element of elements) {
            this.parallaxElements.push(element.querySelector('.promo-text__parallax'));

            const start = count === 0 ? calcPoint * this.firstFrameShift : calcPoint;
            calcPoint += step;
            const end = calcPoint;
            this.elements.push({
                'element': element,
                'start': start,
                'end': end,
                'id': count
            });

            main.setLoaderPercent(1);

            count++;
        }
    },
    reactToResize: function () {
        const config = main.detectScroll.getConfig(this.configName);
        this.point = config.height / (this.elements.length + 2);
        let calcPoint = this.point;
        const step = (config.height - this.point * 3) / this.elements.length;
        let count = 0;

        for (const index in this.elements) {
            const start = count === 0 ? calcPoint * this.firstFrameShift : calcPoint;
            calcPoint += step;
            const end = calcPoint;
            this.elements[index].start = start;
            this.elements[index].end = end;

            count++;
        }

        for (const element of this.parallaxElements) {
            element.style.transform = '';
        }

        this.reactToScroll(main.detectScroll.getSingleScrollData(this.configName));
    },
    reactToScroll: function (data) {
        let foundElement = -1;

        for (let i = 0, size = this.elements.length; i < size; i++) {
            const item = this.elements[i];

            if (
                item.start <= data.localOffset && item.end > data.localOffset
            ) {
                if (item.element.classList.contains('_invisible_down') || item.element.classList.contains('_invisible_up')) {
                    foundElement = item.element;
                }
                if (window.innerWidth > 767) this.setParallaxOffset(i, (data.localOffset - item.start) - (item.end - item.start) / 2); //localScroll
                break;
            }

            if (i === 0 && data.direction < 0 && data.localOffset < item.start) {
                foundElement = 0;
                break;
            }

            if (i === size - 1 && data.direction > 0 && data.localOffset > item.end) {
                foundElement = 1;
                break;
            }
        }

        if (foundElement !== -1) {
            let isFound = false;

            for (let i = 0, size = this.elements.length; i < size; i++) {
                const item = this.elements[i];
                const element = item.element;

                if (element !== foundElement) {
                    element.classList.remove('_visible');

                    if (foundElement === 0) {
                        element.classList.add('_invisible_down');
                    } else if (foundElement === 1) {
                        element.classList.add('_invisible_up');
                    } else if (!isFound) {
                        element.classList.add('_invisible_up');
                    } else {
                        element.classList.add('_invisible_down');
                    }
                } else {
                    element.classList.remove('_invisible_down', '_invisible_up');
                    element.classList.add('_visible');
                    riveHandObject.fire(item.id);
                    isFound = true;
                }
            }
        }
    },
    setParallaxOffset: function (id, scroll) {
        const parallaxElement = this.parallaxElements[id];
        //scroll = Math.pow(scroll * .007, 3);
        scroll = scroll * this.parallaxFriction;

        parallaxElement.style.transform = 'translate3d(0, ' + (-scroll) + 'px, 0)';
    },
};
